/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('RecipientFastAuth', function ($scope, recipientService, $rootScope) {

    $scope.rows = [];    

    /*
     * pagination
     */

    $scope.pagination = {
        currentPage: 1,
        totalItems: 1,
        itemsPerPage: 1
    };

    $scope.setPage = function () {
        $rootScope.checkboxList.clear();
        $scope.list.request($scope.pagination.currentPage);
    };

    /*
     * 
     */

    $scope.list = {
        "checkbox": {
            "all": false,  
            "change": function(index){
                $scope.list.checkbox.all = false;
                $rootScope.checkboxList.change(index);
            },
            "allChange": function(){                
                if($scope.list.checkbox.all){
                    for(var i=0 ; i<$scope.rows.length; i++){
                        $rootScope.checkboxList.ids[i] = $scope.rows[i].id;
                        $rootScope.checkboxList.change(i);
                    }
                }
            }
        },
        "request": function (page) {            
            var promise = recipientService.unverified(page);
            promise.then(
                    function (payload) {
                        $scope.rows = payload.data.list.data;
                        $scope.pagination = {
                            totalItems: payload.data.list.total,
                            currentPage: payload.data.list.current_page,
                            itemsPerPage: payload.data.list.per_page
                        };
                    },
                    function (errorPayload) {
                        $rootScope.notification.show('error', 'Wystąpił błąd podczas próby pobrania niezwerifikowanych odbiorców');
                    });
        },
        "verify": function(){                
            if($rootScope.checkboxList.idsCount==0){
                $rootScope.notification.show('error','Nie wybrano odbiorców do weryfikacji');
            }else{
                var promise = recipientService.verify($rootScope.checkboxList.get());
                promise.then(
                        function (payload) {                            
                            if(payload.data.code){
                                $rootScope.notification.show('success',payload.data.msg);
                                $scope.list.request(1);
                                $scope.list.checkbox.all = false;
                                $rootScope.checkboxList.clear();
                            }else{
                                $rootScope.notification.show('error',payload.data.msg);
                            }
                        },
                        function (errorPayload) {
                            $rootScope.notification.show('error', 'Wystąpił błąd przy próbie weryfikacji odbiorców');
                        });
            }
        }
    };

    $rootScope.checkboxList.clear();
    $scope.list.request(1);       
});
                  